export default "__VITE_ASSET__BeuOvwT2__"